import React from "react";
import Grid from "@mui/material/GridLegacy";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

type Props = {
  amount: string | number;
  currency: string;
  currencies: string[];
  onAmountChange: (v: string | number) => void;
  onCurrencyChange: (v: string) => void;
};

export default function LeftInput({
  amount,
  currency,
  currencies,
  onAmountChange,
  onCurrencyChange,
}: Props) {
  return (
    <Grid item xs={12} md={5}>
      <TextField
        fullWidth
        label="მინდა გავყიდო"
        value={amount}
        onChange={(e) => onAmountChange(e.target.value)}
        autoComplete="off"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Select
                value={currency}
                onChange={(e) => onCurrencyChange(e.target.value)}
                variant="standard"
                disableUnderline
              >
                {currencies.map((cur) => (
                  <MenuItem key={cur} value={cur}>
                    {cur}
                  </MenuItem>
                ))}
              </Select>
            </InputAdornment>
          ),
        }}
      />
    </Grid>
  );
}
